import script from "./donations.vue?vue&type=script&setup=true&lang=js"
export * from "./donations.vue?vue&type=script&setup=true&lang=js"

import "./donations.vue?vue&type=style&index=0&id=038b60ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038b60ca"]])

export default __exports__